import React, { useState } from "react";
import Axios from "axios";
import { Redirect, withRouter } from "react-router";
import { LoginLayout } from "../../components/login/LoginLayout";
const Vaccine = props => {
  console.log(props.Login);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [wrongPassFlag, setwrongPassFlag] = useState(false);
  const [logging, setLogging] = useState(false);

  const [showNo, setShowNo] = useState(false);

  let showYes = false;

   const CheckYes = () => {
    fetch("api/Login/AnswerVaccine/1")
    .then(response => {
        setTimeout(function(){        window.location.href = ""; }, 1000);

    })



  }

  const CheckNo = () => {

    fetch("api/Login/AnswerVaccine/0")
    .then(response => {
        setShowNo( true);
        setTimeout(function(){        window.location.href = ""; }, 6000);

    })

}



  return (
    <div>
      {!props.isLogin && (
        <LoginLayout  >

            {showNo && <h4>
                علي الطلاب الذين لم يتمكنوا من التطعيم سرعه التسجيل علي موقع وزارة الصحه 
وارسال رقم التسجيل المكون من ٢٠ رقم علي student portal
                
                </h4>}
            
{!showNo && !showYes &&
<div>
<h1>
            هل قمت بتلقي اللقاح ؟
            </h1>
            <button
                onClick={CheckYes}
                class="btn btn-primary"
               >
              
نعم              </button>

&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
<button
                onClick={CheckNo}
                class="btn btn-danger"
               >
              
لا              </button>
</div>}
        </LoginLayout>
      )}
    </div>
  );
};

export default withRouter(Vaccine);



// WEBPACK FOOTER //
// ./src/pages/Vaccine/Vaccine.js